module.exports = __webpack_public_path__ + "static/media/filled-inverted-horizontal.8dba5bfd.svg";